<template>
  <div class="share_order_info_wrap">
    <div class="timeline_box">
      <div class="timeline_left">
        <div class="line_t"></div>
        <div class="line_icon"></div>
        <div class="line_b"></div>
      </div>
      <div class="timeline_right">
        <div class="title" v-html="orderInfos.comp_title">
        </div>
        <div class="message" v-html="orderInfos.comp_sub_title">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareOrderInfo',
  props: {
    info: Object,
  },
  computed: {
    orderInfos() {
      const {
        title,
        subTitle,
        replaceInfo = [],
      } = this.info || {};
      let comp_sub_title = subTitle;
      let comp_title = title;
      
      replaceInfo.forEach((item) => {
        comp_title = comp_title.replace(item.key,`<span>${item.value}</span>`)
        comp_sub_title = comp_sub_title.replace(item.key,`<span>${item.value}</span>`)
      })

      return {
        comp_sub_title,
        comp_title,
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.share_order_info_wrap {
  padding: 0 rem(24) rem(28) rem(24);
  background-color: #fff;
  border-radius: rem(12);
  color: #000;
}

.timeline_box {
  min-height: rem(164);
  display: flex;
  .timeline_left {
    width: rem(44);
    .line_t {
      margin-left: rem(10);
      width: rem(4);
      height: rem(42);
      background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 20%, #E6E6E6 100%);
      border-radius: rem(8);
    }
    .line_icon {
      margin: rem(8) 0;
      width: rem(24);
      height: rem(24);
      @include themeBackgroundColor();
      border-radius: 50%;
    }
    .line_b {
      margin-left: rem(10);
      width: rem(4);
      height: calc(100% - 44px);
      background-image: linear-gradient(180deg, #E6E6E6 44%, rgba(244,244,244,0.00) 100%);
      border-radius: rem(8);
    }
  }
  .timeline_right {
    flex: 1;
    color: #000;
    .title {
      padding-top: rem(40);
      font-size: rem(36);
      line-height: rem(42);
      font-weight: 500;
      font-family: 'Aspira Medium';
      word-break: break-all;
      word-wrap: break-word;
      @include ellipsis(2);
    }
    .message {
      padding-top: rem(14);
      font-size: rem(28);
      line-height: rem(34);
      font-family: 'Aspira Light';
      font-weight: 200;
      word-break: break-all;
      word-wrap: break-word;
      ::v-deep span {
        @include font-color();
        font-weight: 500;
        font-family: 'Aspira Medium';
      }
    }
  }
}
</style>
